import React from 'react';
import { connect } from 'react-redux';
import { fetchVideoModel } from './VideoBlock.action';
import VideoBlock from './VideoBlock';

class VideoBlockContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchData(this.props.blockId);
    }
    render() {
        return (
            <VideoBlock {...this.props} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: (blockId) => dispatch(fetchVideoModel(blockId))
    }

}
const mapStateToProps = state => {
    return {
        result: state.VideoBlockReducer.result
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VideoBlockContainer);